import styles from "../css/scanner.module.scss";

const ScanOverlay = () => {
  return (
    <div className={styles["clinical-overlay"]}>
      <div className={styles["clinical-scan-frame"]}>
        <span className={`${styles["frame-corner"]} ${styles["top-left"]}`} />
        <span className={`${styles["frame-corner"]} ${styles["top-right"]}`} />
        <span
          className={`${styles["frame-corner"]} ${styles["bottom-left"]}`}
        />
        <span
          className={`${styles["frame-corner"]} ${styles["bottom-right"]}`}
        />

        <div className={styles["clinical-scan-line"]} />
      </div>
    </div>
  );
};

export default ScanOverlay;